<template>
</template>

<script>
export default {
  name: 'User',
  props:['user'],
  methods:{
    getUser(){
        return this.user
    }
  }
}
</script>

<style lang="css" scoped>
</style>
